// @core/api/endpoints/document/request_acknowledgment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RequestAcknowledgmentRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Request acknowledgment
 * Requests one or more actors to acknowledge reading the document-aware entity. Sends notifications.
 */
export async function RequestAcknowledgment(
  target_type: string,
  target_id: string,
  data: RequestAcknowledgmentRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/acknowledgments`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
